export const categoryMap = {
  notice: "通知",
  seminar: "研讨会",
  enrollment: "会议报名",
};

export const getCategoryName = (category: ArticleCategory) =>
  categoryMap[category];
